import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";
import { TaskInterface } from "services/api/AppWeb_Lead/tarefas-lead-v2";

export interface ResumoCorretorTarefas {
  idCorretor365: string;
  nomeCorretor: string;
  fotoUrlCorretor: string;
  qtdTarefasHoje: number;
  qtdTarefasAtrasas?: number;
  qtdTarefasAtrasadas?: number;
  qtdLeads: number;
}

export interface TarefasGerenciaisData {
  qtdTarefasAtrasadas: number;
  qtdTarefasHoje: number;
  resumosCorretores: ResumoCorretorTarefas[];
  tarefas: TaskInterface[];
}

export interface TarefasGerenciaisResponse {
  data: TarefasGerenciaisData;
  pagination?: {
    currentPage: number;
    totalItemsPage: number;
    quantityPages: number;
    totalItems: number;
  };
}

export function useTarefasGerenciais(
  props: QueryGlobalInterface & { enabled?: boolean }
) {
  const fetchData = async (): Promise<TarefasGerenciaisResponse> => {
    const response = await instance.post(
      `${leadsWebEnviroment}/common/tarefas-leads/tarefas-gerenciais/v1`
    );

    return {
      data: response?.data?.data as TarefasGerenciaisData,
    };
  };

  return useQuery({
    queryFn: fetchData,
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled ?? true,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar tarefas gerenciais. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
}

export interface TarefasGerenciaisPorCorretorRequest {
  idCorretor365: string;
  atrasadas: boolean;
  hoje: boolean;
  totalItensRetorno?: number;
}

export interface TarefasGerenciaisPorCorretorPage {
  tarefas: TaskInterface[];
  pagination?: {
    currentPage: number;
    totalItemsPage: number;
    quantityPages: number;
    totalItems: number;
  };
}

export function useTarefasGerenciaisPorCorretor(
  props: TarefasGerenciaisPorCorretorRequest & QueryGlobalInterface
) {
  const totalItensRetorno = props.totalItensRetorno ?? 10;

  const fetchPage = async ({
    pageParam = 1,
  }): Promise<TarefasGerenciaisPorCorretorPage> => {
    const response = await instance.post(
      `${leadsWebEnviroment}/common/tarefas-leads/tarefas-gerenciais-por-corretor/v1`,
      {
        idCorretor365: props.idCorretor365,
        atrasadas: props.atrasadas,
        hoje: props.hoje,
        paginaAtual: pageParam,
        totalItensRetorno,
      }
    );

    const rawData = response?.data?.data;
    const tarefas: TaskInterface[] = Array.isArray(rawData)
      ? rawData
      : rawData?.tarefas ?? [];

    return {
      tarefas,
      pagination: response?.data?.pagination,
    };
  };

  return useInfiniteQuery({
    queryFn: fetchPage,
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: Boolean(props.idCorretor365),
    getNextPageParam: (lastPage) => {
      const current = lastPage?.pagination?.currentPage ?? 0;
      const total = lastPage?.pagination?.quantityPages ?? 0;
      return current < total ? current + 1 : undefined;
    },
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar tarefas do corretor. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
}
